import { ArrowDropDown, Search } from "@mui/icons-material"
import { Grid, Paper, Typography } from "@mui/material"
import { FunctionComponent, SVGProps, useState } from "react"
import { useNavigate } from "react-router-dom"
import useGlobalStore from "../../stores/global"
import { Button, CompactTable, StyledPaper } from "../commons"
import { SearchBox, constructMarketTableMobile } from "./table"

export interface MarketTableType {
  title: string
}

function createData(
  icon: FunctionComponent<SVGProps<SVGSVGElement>>,
  asset: string,
  name: string,
  price: number,
  totalSupplied: number,
  totalSuppliedCap: number,
  supplyApy: number,
  totalBorrowed: number,
  totalBorrowedCap: number,
  borrowApy: number,
  utilizationRate: number,
  contractAddress: `0x${string}`
) {
  return { icon, asset, price, totalSupplied, supplyApy, totalBorrowed, borrowApy, utilizationRate, totalSuppliedCap, totalBorrowedCap, name, contractAddress };
}

const MarketTable = (props: MarketTableType) => {
  const { title } = props
  const [search, setSearch] = useState('')
  const [openSearch, setOpenSearch] = useState(false)
  const [sort] = useState<'asset' | 'name' | 'totalSupplied' | 'totalBorrowed' | 'supplyApy' | 'borrowApy'>('totalSupplied')
  const markets = useGlobalStore((state) => state.markets)
  const tableRows = markets.map((market) => {
    return createData(
      market.icon,
      market.asset,
      market.name,
      market.price,
      market.totalSupplied,
      market.totalSuppliedCap,
      market.supplyApy,
      market.totalBorrowed,
      market.totalBorrowedCap,
      market.borrowApy,
      market.utilizationRate,
      market.contractAddress
    )
  }).sort((a, b) => a[sort].toString().localeCompare(b[sort].toString()))
    .filter((market) => market.asset.toLowerCase().includes(search.toLowerCase())
      || market.name.toLowerCase().includes(search.toLowerCase()))

  const navigate = useNavigate()
  const optionUI = <Grid container justifyContent={'space-between'}
    alignItems={'flex-start'} flexDirection={'row'} gap={1} sx={{ width: '100%' }}>
    <Button transparent sx={{ backgroundColor: 'background.translucent' }}>
      <div style={{ display: 'flex', placeItems: 'center', padding: '0rem 0rem 0rem 0.5rem', gap: '0.5rem' }}>
        <Typography variant="s">Sort: Asset</Typography> <ArrowDropDown sx={{ marginLeft: 'auto' }} />
      </div>
    </Button>
    {
      openSearch ? <div style={{ maxWidth: '10rem' }}><SearchBox callback={setSearch} sx={{ padding: '0.15rem 0rem' }} /></div>
        :
        <Button transparent sx={{ backgroundColor: 'background.translucent', minWidth: '3.2rem' }}>
          <div style={{ display: 'flex', placeItems: 'center', padding: '0rem 0rem 0rem 0rem', gap: '0.5rem' }}>
            <Search sx={{ cursor: 'pointer' }} onClick={() => setOpenSearch((prev) => !prev)} />
          </div>
        </Button>
    }
    {/* <Grid item>
      <SearchBox />
    </Grid> */}
  </Grid>

  const tableMarketData = constructMarketTableMobile(tableRows, navigate)

  return (
    <Grid item container>
      <StyledPaper color='primary' transparent sx={{
        // backgroundColor: '#283D3E', 
        minWidth: '12.8rem',
        width: '100%',
        borderRadius: 1,
        padding: '0px', //to show border
      }}>
        <Grid container item>
          <Grid item xs={12}>
            <Button sx={{
              placeContent: 'flex-start', padding: '0.5rem 1rem',
              border: 0, borderRadius: 0,
              background: `rgb(255,255,255, 0.24)`,
              width: '100%',
              '&:hover': {
                background: `rgb(255,255,255,0.24)`,
              }
            }}>
              <Typography variant="r" color='text.primary' component={'span'}>
                {title}
              </Typography>
            </Button>
          </Grid>
        </Grid>
        <Grid container flexDirection={'column'}>
          <Paper sx={{
            padding: '0.5rem 0rem',
            width: '100%'
          }}>
            <Grid container alignItems={'center'}
              justifyContent={'flex-start'}>
              <Grid item justifyItems={'flex-start'} sx={{ padding: '0.5rem 1rem', width: '100%' }}>
                {optionUI}
              </Grid>
              <Grid item sx={{ marginTop: 1.5 }}>
                <CompactTable tableContent={tableMarketData} />
              </Grid>
            </Grid>
          </Paper>
        </Grid>
      </StyledPaper>
    </Grid >
  )
}

export default MarketTable